import { lazy } from 'solid-js'
import { messages } from '../../pages/newsroom-admin-editor-page/newsroom-admin-editor-page-routing.messages.en.js'

const NewsroomAdminEditorPage = lazy(() => import('../../pages/newsroom-admin-editor-page/newsroom-admin-editor-page.jsx'))

export const newsroomAdminEditorCreate = {
    component: NewsroomAdminEditorPage,
    descriptionMessage: messages.descriptionMessage,
    noIndex: true,
    path: '/admin/newsroom/editor',
    showFooter: false,
    showHeader: true,
    titleMessage: messages.titleMessage,
}

export const newsroomAdminEditorEdit = {
    component: NewsroomAdminEditorPage,
    descriptionMessage: messages.descriptionMessage,
    noIndex: true,
    path: '/admin/newsroom/editor/:article_id',
    showFooter: false,
    showHeader: true,
    titleMessage: messages.titleMessage,
}
